// Determine if mobile size
function isMobile() {
        
    // Get if mobile or not
    if (window.outerHeight) {
        browserHeight = window.outerHeight;
        browserWidth = window.outerWidth;
    }
    else {
        browserWidth = document.body.clientWidth;
        browserHeight = document.body.clientHeight; 
    }
    if (browserWidth < 1024) {
        return true;
    }
    return false;
}

// Banner
function bannerAnimate(){
    const banner = document.getElementById("banner");
    const bannerText = document.getElementById("banner-text");
    const bannerSlant = document.getElementById("banner-slant");
    const bannerSlant2 = document.getElementById("banner-slant2");
    const bannerText2 = document.getElementById("banner-text2");
    const bannerSlant3 = document.getElementById("banner-slant3");
    const bannerSlant4 = document.getElementById("banner-slant4");
    const mobile = isMobile();
    var slantModifier = 5;
    if (mobile == true) {
        var slantModifier = 20;
    }

    // Fade in banner elements
    fadeIn(bannerSlant, 800);
    fadeIn(bannerSlant2, 800);

    const bannerStyle = window.getComputedStyle(banner);
    const bannerTextStyle = window.getComputedStyle(bannerText);

    // Get the banner height
    const bannerHeight = parseInt(bannerStyle.height, 10);
    const bannerPadding = parseInt(bannerStyle.paddingTop, 10);
    const bannerHeightAndPadding = bannerHeight + (bannerPadding * 2);

    // Get the text height
    const bannerTextHeight = parseInt(bannerTextStyle.height, 10);
    const bannerTextPadding = parseInt(bannerTextStyle.paddingTop, 10);
    const bannerTextHeightAndPadding = bannerTextHeight + (bannerTextPadding * 2);
    
    // Move banner text to vertical middle
    var bannerTextTop = ((bannerHeightAndPadding - bannerTextHeightAndPadding) / 2);
    bannerText.style.marginTop = `${bannerTextTop}px`;

    // Change the topSlant position and size to match the text
    const topWidth = parseInt(bannerTextStyle.width, 10);
    bannerSlant.style.top = `${bannerTextTop - (bannerTextPadding * 2)}px`;
    bannerSlant.style.width = `${topWidth + (bannerTextPadding * 2)}px`;
    bannerSlant.style.borderBottom = `${bannerTextHeightAndPadding + (bannerTextPadding * 2)}px solid #FFF`;
    bannerSlant.style.borderLeft = `${bannerTextHeightAndPadding / slantModifier}px solid transparent`;

    // Change the bannerSlant2 position and size
    bannerSlant2.style.top = `${bannerTextTop - (bannerTextPadding * 2) + bannerTextPadding}px`;
    bannerSlant2.style.width = `${topWidth + (bannerTextPadding * 3.2)}px`;
    bannerSlant2.style.borderBottom = `${bannerTextHeightAndPadding + (bannerTextPadding * 2)}px solid #5AA4ED`;
    bannerSlant2.style.borderLeft = `${bannerTextHeightAndPadding / slantModifier}px solid transparent`;

    // Fade in banner text
    fadeIn(bannerText, 800);
}